<template>
  <partner-layout>
    <v-container v-if="profile">
      <v-layout wrap>
        <v-flex xs12 sm6 class="px-2 py-1">
          <v-card>
            <v-card-text class="py-4">
              <div class="text-xs-center">
                <v-avatar
                  size="80"
                  color="primary"
                  class="white--text"
                  style="font-family: serif; font-size: 36px"
                >
                  <template v-if="profile.current_exp > profile.tier3">III</template>
                  <template v-else-if="profile.current_exp > profile.tier2">II</template>
                  <template v-else>I</template>
                </v-avatar>
                <div class="caption">
                  Teir
                  <template v-if="profile.current_exp > profile.tier3">3</template>
                  <template v-else-if="profile.current_exp > profile.tier2">2</template>
                  <template v-else>1</template>
                  <v-icon small>info</v-icon>
                </div>
              </div>

              <v-progress-linear
                color="error"
                height="20"
                :value="computedProgress"
                style="border-radius: 50px"
              ></v-progress-linear>
              <div class="caption text-xs-center primary--text" style="margin-top: -10px">
                ({{ profile.current_exp }}/<template v-if="profile.current_exp > profile.tier3">{{
                  profile.current_exp
                }}</template>
                <template v-else-if="profile.current_exp > profile.tier2">{{
                  profile.tier3
                }}</template>
                <template v-else>{{ profile.tier2 }}</template
                >)
              </div>

              <div class="text-xs-center">
                <div class="mt-4 mb-2 grey--text caption">Your Support Code</div>
                <div
                  class="grey lighten-3 py-2"
                  style="border-radius: 50px"
                  v-clipboard:copy="profile.code"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onCopyError"
                >
                  {{ profile.code ? profile.code : '-' }} <v-icon small>file_copy</v-icon>
                </div>
              </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <h3 class="title primary--text mt-0">My Personal Info</h3>

              <div class="caption">My Fullname</div>
              <div class="primary--text mb-3">{{ profile.fullname ? profile.fullname : '-' }}</div>

              <v-layout wrap>
                <v-flex xs6>
                  <div class="caption">Date of Birth</div>
                  <div class="primary--text mb-3">
                    {{ profile.dob ? profile.dob : '-' }}
                  </div>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs6>
                  <div class="caption">Tel</div>
                  <div class="primary--text mb-3">
                    {{ profile.contact ? profile.contact : '-' }}
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="caption">Email</div>
                  <div class="primary--text mb-3">{{ profile.email ? profile.email : '-' }}</div>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-flex xs6>
                  <div class="caption">Facebook</div>
                  <div class="primary--text mb-3">
                    {{ profile.facebook ? profile.facebook : '-' }}
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="caption">Facebook Page</div>
                  <div class="primary--text mb-3">
                    {{ profile.facebook_page ? profile.facebook_page : '-' }}
                  </div>
                </v-flex>

                <v-flex xs6>
                  <div class="caption">LINE ID</div>
                  <div class="primary--text mb-3">{{ profile.lineid ? profile.lineid : '-' }}</div>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-layout wrap>
                <v-flex xs6>
                  <div class="caption">Application Date</div>
                  <div class="primary--text mb-3">
                    <template v-if="profile.application_date">{{
                      profile.application_date | DateFormat('DD MMM YYYY HH:mm')
                    }}</template>
                    <template v-else>-</template>
                  </div>
                </v-flex>
                <v-flex xs6>
                  <div class="caption">Contact Expired Date</div>
                  <div class="primary--text mb-3">
                    <template v-if="profile.contact_expire_date">{{
                      profile.contact_expire_date | DateFormat('DD MMM YYYY HH:mm')
                    }}</template>
                    <template v-else>-</template>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 class="px-2 py-1">
          <v-card>
            <v-card-text>
              <h3 class="title primary--text mt-0">My Bank Info</h3>

              <div class="caption">Bank Book Name</div>
              <div class="primary--text mb-3">
                {{ profile.bank_book_name ? profile.bank_book_name : '-' }}
              </div>

              <div class="caption">Bank Book Number</div>
              <div class="primary--text mb-3">
                {{ profile.bank_book_number ? profile.bank_book_number : '-' }}
              </div>

              <div class="caption">Bank Name</div>
              <div class="primary--text mb-3">
                {{ profile.bank_name ? profile.bank_name : '-' }}
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
      >{{ $t('Code Copied') }}!</v-snackbar
    >
  </partner-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  data() {
    return {
      // profile: null
      showCopy: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      loading: 'getLoadingPartnerProfile',
      profile: 'getPartnerProfile'
    }),
    computedProgress() {
      let progress = 0
      if (this.profile) {
        try {
          if (parseInt(this.profile.current_exp) > parseInt(this.profile.tier3)) return 100
          else if (parseInt(this.profile.current_exp) > parseInt(this.profile.tier2))
            return (parseInt(this.profile.current_exp) * 100) / parseInt(this.profile.tier3)
          else return (parseInt(this.profile.current_exp) * 100) / parseInt(this.profile.tier2)
        } catch (error) {}
      }
      return progress
    }
  },
  async mounted() {
    // try {
    //   var response = await this.getPartnerProfile()
    //   if (response.responsecode == 200 && response.data && response.data.length > 0) {
    //     this.profile = response.data[0]
    //   } else {
    //     throw 'not found profile'
    //   }
    // } catch (error) {
    //   console.log(error)
    // }
  },
  methods: {
    // getPartnerProfile() {
    //   var data = {
    //     partner_code: this.$store.state.partner_code
    //   }
    //   return new Promise((resolve, reject) => {
    //     api.getPartnerProfile(data, (error, response) => {
    //       if (error) {
    //         reject(error)
    //       }
    //       resolve(response)
    //     })
    //   })
    // }
    onCopy: function () {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError: function () {}
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/partner/Profile.vue